import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

/**
 * Higher-order component to restrict access based on user roles.
 * Role comes from the server session (/auth/me), not browser storage.
 * Redirects to /login if not authenticated or not authorized.
 */
const withAuthorization = (Component, allowedRoles) => {
  return (props) => {
    const { isLoggedIn, role, loading } = useAuth();

    // Wait for the session check before deciding
    if (loading) {
      return (
        <div className="flex justify-center items-center h-screen">
          <div className="animate-spin rounded-full h-12 w-12 border-b-4 border-blue-600" />
        </div>
      );
    }

    if (!allowedRoles || !Array.isArray(allowedRoles) || !isLoggedIn || !allowedRoles.includes(role)) {
      return <Navigate to="/login" replace />;
    }

    return <Component {...props} />;
  };
};

export default withAuthorization;
